
























































































































































































import { Vue, Component, } from "@/shared/vuepack";
import * as hsaBankUrls from "@/shared/hsaBankUrls";
import { openUrl } from "@/shared/urlHelper";

@Component({
  components: {
  }
})
export default class AvidiaForms extends Vue {
  HsaBankUrls = hsaBankUrls;

  clickLink (event) {
    openUrl(event.currentTarget.href);
  }
}
